import { Content } from "@robe/core";
import { useContext } from "react";
import { XcoreData, XcoreDataContext } from "../context/XcoreDataContext";

/**
 * `useData` returns content of the xcore context with SSG/SSR props and utilities.
 *
 * @template PageContent - The type of page content.
 * @template ContentSingletons - The type of the array of content singletons.
 * @template MultipleContents - The type of the array of multiple contents.
 * @template Data - The type of the data.
 * @template Layout - The type of app layout.
 */
export const useData = <
  PageContent extends Content = Content,
  ContentSingletons extends Content[] = Content[],
  MultipleContents extends Content[] = Content[],
  Data = {},
  Layout extends {} = {},
>() => useContext<XcoreData<PageContent, ContentSingletons, MultipleContents, Data> & Layout>(XcoreDataContext as any);
